const riot = require('riot');

riot.tag2('module-projects', '<div class="sticky t0 l0 z1 bg-background_dark_primary" if="{!minSize}"> <div class="f flex-between fm px12 pt16 pb12"> <button class="f fm tooltip" onclick="{opts.onworkspaceclick}" aria-label="ワークスペース一覧を{opts.is_visible ? &quot;閉じる&quot; : &quot;開く&quot;}" data-tooltip-offset-top="-5"> <div class="relative"><i class="fs20 icon-{opts.is_visible ? &quot;arrow-left&quot; : &quot;menu&quot;}"></i></div> <div class="f fm py6 pr4 pl8"><img class="flex-fixed s24 object-fit-cover rounded-8 mr8" riot-src="{app.utils.getImageUrl(app.store.workspace.data.icon_image)}"> <div class="font-lato fs16 bold line-clamp-1 word-break-all lh13">{app.store.workspace.data.name}</div> </div> </button> <div class="f fm flex-fixed mrn8"> <button class="p8 tooltip" onclick="{openSwitcher}" aria-label="検索" data-tooltip-offset-top="-5"><i class="icon-search fs16 text-label_white_medium"></i></button> <button class="p8 tooltip" if="{app.store.workspace_user.data.role !== &quot;guest&quot;}" onclick="{onOpenActionSheet}" aria-label="メニュー" data-tooltip-offset-top="-5"><i class="icon-more_horizontal fs16 text-label_white_medium"></i></button> </div> </div> <div class="s-hide"><a class="f fm fbw px12 hover-trigger hover-bg-label_white_disabled mb12 {&quot;bg-label_white_disabled&quot; : isActive(&quot;inboxes&quot;)}" href="/workspaces/{app.store.workspace.id}/inboxes" onclick="{() =&gt; capacitor.hapticsImpactLight()}"> <div class="relative f fm hover-text-white {isActive(&quot;inboxes&quot;) || hasUnread() ? &quot;text-white&quot; : &quot;text-label_white_medium&quot;} {&quot;bold&quot; : hasUnread()}"><i class="icon-inbox fs20"></i> <div class="font-lato lh13 px8 py7">Inbox</div> </div> <div class="f fm"> <div class="flex-fixed {mr8 : hasMention()}" if="{app.store.inboxesStore}"> <div class="text-label_white_primary fs12 font-lato" if="{app.store.inboxesStore.items.length}">{app.store.inboxesStore.items.length}</div> </div> <div class="f fh s16 pb2 circle bg-alert_primary lh13 font-lato fs10 text-white bold" if="{hasMention()}">@</div> </div></a><a class="f fm fbw px12 hover-trigger hover-bg-label_white_disabled mb12" href="/workspaces/{app.store.workspace.id}/users_management" onclick="{() =&gt; capacitor.hapticsImpactLight()}"> <div class="relative f fm hover-text-white"><img class="s20 opacity-70" src="/images/icons/user_check.svg"> <div class="font-lato lh13 text-label_white_medium px8 py7">Assign</div> </div></a><a class="f fm fbw px12 hover-trigger hover-bg-label_white_disabled mb12 {isActive(&quot;notifications&quot;) ? &quot;text-white bg-label_white_disabled&quot; : &quot;text-label_white_medium&quot;}" href="/workspaces/{app.store.workspace.id}/notifications" onclick="{() =&gt; capacitor.hapticsImpactLight()}"> <div class="f fm hover-text-white"><i class="icon-notification fs20"></i> <div class="px8 py7 lh13">通知</div> </div> <div class="p4 tooltip hover-show mrn4 s-hide" data-current="notifications" onclick="{openPopupNotifications}" aria-label="プレビューを表示"><i class="icon-preview fs20"></i></div></a><a class="f fm fbw px12 hover-trigger hover-bg-label_white_disabled mb12 {&quot;bg-label_white_disabled&quot; : isActive(&quot;reminds&quot;)}" href="/workspaces/{app.store.workspace.id}/notifications/reminds" onclick="{() =&gt; capacitor.hapticsImpactLight()}"> <div class="f fm hover-text-white {isActive(&quot;reminds&quot;) || hasRemind() ? &quot;text-white&quot; : &quot;text-label_white_medium&quot;} {&quot;bold&quot; : hasRemind()}"><i class="icon-remind fs20"></i> <div class="lh13 px8 py7">リマインド</div> </div> <div class="f fm"> <div> <div class="text-label_white_primary fs12 font-lato" if="{app.store.getWorkspaceUser().data.remind_count}">{app.store.getWorkspaceUser().data.remind_count}</div> </div> <div class="p4 tooltip hover-show mrn4 s-hide" data-current="reminds" onclick="{openPopupNotifications}" aria-label="プレビューを表示"><i class="icon-preview fs20"></i></div> </div></a></div> </div> <div class="sticky t0 l0 z1 bg-background_dark_primary" if="{minSize}"> <div class="f fh pt16 pb10 border-bottom border-background_dark_quaternary mb8"> <div class="relative f fm fclm w80 cursor-pointer" onclick="{opts.onworkspaceclick}"> <div class="f fm mb4"> <div class="relative s32 tooltip" aria-label="{item.relation.workspace.data.name}" data-tooltip-position="right"><img class="s-full object-fit-cover rounded-8" riot-src="{app.utils.getImageUrl(app.store.getWorkspaceUser().relation.workspace.data.icon_image)}"> <div class="absolute tn6 rn10 f fh s20 circle bg-background_dark_primary" if="{app.store.getWorkspaceUser().hasUnreadMention()}"> <div class="fh f s16 circle bg-alert_primary"> <div class="pb2 text-white fs10 font-lato bold">@</div> </div> </div> <div class="absolute tn3 rn3 f fh s12 circle bg-background_dark_primary" if="{!app.store.getWorkspaceUser().hasUnreadMention() &amp;&amp; app.store.getWorkspaceUser().hasUnread()}"> <div class="fh f s8 circle bg-alert_primary"></div> </div> </div> </div> <div class="absolute l6 t9"><i class="icon-{!opts.is_visible ? &quot;arrow-left&quot; : &quot;arrow-right&quot;}"></i></div> <div class="f fm mrn6"> <div class="w50 text-center font-lato bold line-clamp-1 word-break-all lh13">{app.store.workspace.data.name}</div> <button class="p2 tooltip mln2" if="{app.store.workspace_user.data.role !== &quot;guest&quot;}" onclick="{onOpenActionSheet}" aria-label="メニュー" data-tooltip-offset-top="-5"><i class="icon-more_horizontal fs16 text-label_white_medium"></i></button> </div> </div> </div><a class="f fh px12 py4 hover-trigger hover-bg-label_white_disabled mb12 {&quot;bg-label_white_disabled&quot; : isActive(&quot;inboxes&quot;)}" href="/workspaces/{app.store.workspace.id}/inboxes"> <div class="f fm fclm hover-text-white {isActive(&quot;inboxes&quot;) || hasUnread() ? &quot;text-white&quot; : &quot;text-label_white_medium&quot;} {&quot;bold&quot; : hasUnread()}"> <div class="relative"><i class="icon-inbox fs26 mb4"></i> <div class="absolute tn6 rn6 f fh s16 circle bg-background_dark_primary" if="{app.store.inboxesStore.items.length}"><i class="flex-fixed fh f s14 circle bg-alert_primary fs11 text-white font-lato icon-mention" if="{hasMention()}"></i> <div class="flex-fixed fh f s14 circle bg-alert_primary fs10 text-white font-lato" if="{!hasMention()}">{app.store.inboxesStore.items.length}</div> </div> </div> <div class="fw5 fs10 word-break-keep">Inbox</div> </div></a><a class="f fh px12 py4 hover-trigger hover-bg-label_white_disabled mb12 {&quot;bg-label_white_disabled&quot; : isActive(&quot;users_management&quot;)}" href="/workspaces/{app.store.workspace.id}/users_management"> <div class="f fm fclm hover-text-white"> <div class="relative"><img class="s28 opacity-60" src="/images/icons/user_check.svg"></div> <div class="fw5 fs10 word-break-keep text-label_white_medium">Assign</div> </div></a><a class="f fh px12 py4 hover-trigger hover-bg-label_white_disabled mb12 {isActive(&quot;notifications&quot;) ? &quot;text-white bg-label_white_disabled&quot; : &quot;text-label_white_medium&quot;}" href="/workspaces/{app.store.workspace.id}/notifications"> <div class="f fm fclm hover-text-white"><i class="icon-notification fs26 mb4"></i> <div class="fw5 fs10 word-break-keep">通知</div> </div></a><a class="f fh px12 py4 hover-trigger hover-bg-label_white_disabled mb12 {&quot;bg-label_white_disabled&quot; : isActive(&quot;reminds&quot;)}" href="/workspaces/{app.store.workspace.id}/notifications/reminds"> <div class="f fm fclm hover-text-white {isActive(&quot;reminds&quot;) || hasRemind() ? &quot;text-white&quot; : &quot;text-label_white_medium&quot;} {&quot;bold&quot; : hasRemind()}"> <div class="relative"><i class="icon-remind fs26 mb4"></i> <div class="absolute tn6 rn6 f fh s16 circle bg-background_dark_primary" if="{app.store.getWorkspaceUser().data.remind_count}"> <div class="flex-fixed fh f s14 circle bg-alert_primary fs10 text-white font-lato">{app.store.getWorkspaceUser().data.remind_count}</div> </div> </div> <div class="fw5 fs10 word-break-keep">リマインド</div> </div></a> <button class="w-full f fh px12 py4 hover-trigger hover-bg-label_white_disabled mb12" type="button" onclick="{dashboardItems[2].action}"> <div class="f fm fclm hover-text-white"><i class="icon-mypage fs26 mb4"></i> <div class="fw5 fs10 word-break-keep">マイタスク</div> </div> </button> </div> <div class="f fm overflow-x-scroll scrollbar-none px8 mb16" if="{!minSize}"> <div class="mr8 mr0-last" each="{item in dashboardItems}"> <button class="f fclm w120 rounded-12 border-label_white_medium border p10 hover-trigger hover-bg-label_white_disabled transition-128 active-anim-scale" type="button" onclick="{item.action}"> <div class="mb6"><i class="fs20 icon-{item.icon}"></i></div> <div class="mb8 fs13">{item.name}</div> <div class="fs13 lh10 text-label_white_medium hover-text-white line-clamp-1 word-break-all">{item.status}</div> </button> </div> </div> <div class="f fh fclm py32" if="{opts.is_loading}"> <div data-is="atom-loading"></div> <div class="mt16" data-is="atom-loading-slow"></div> </div> <div class="{minSize ? &quot;py2&quot; : &quot;py8&quot;}" each="{section,key in getSectionedProjects()}" show="{!opts.is_loading}"> <div data-is="module-project-section_" items="{section.projects}" is-close="{section.isClose}" key="{key}" min-size="{minSize}" ontoggle="{onToggle}"></div> </div>', 'module-projects,[data-is="module-projects"]{display:block}', '', function(opts) {
    const SIDEBAR_SETTINGS_KEY = app.data.sidebar_settings_key;

    this.loadSidebarSettings = () => {

      return app.localStorageManager.getFromStorage(SIDEBAR_SETTINGS_KEY);
    };

    let sidebarSettings = this.loadSidebarSettings();

    this.onToggle = (e) => {

      let workspace_settings = sidebarSettings[app.store.workspace_id] || {};
      let section_settings = workspace_settings[e.key] || {};

      section_settings['isClose'] = e.isClose;

      workspace_settings[e.key] = section_settings;

      sidebarSettings[app.store.workspace_id] = workspace_settings;

      app.localStorageManager.saveToStorage(SIDEBAR_SETTINGS_KEY, sidebarSettings);
      this.update();
    };

    const MIN_SIZE = 80;
    this.minSize = false;
    const GUTTER_SIZE = 5;
    this.on('mount', () => {
      if (spat.isNode) return ;
      requestAnimationFrame(() => {
        this.updateMinSize();
      });
      this.update();
    });

    this.updateMinSize = (width= this.root.offsetWidth - GUTTER_SIZE) => {

      let is_min_size = width <= MIN_SIZE;
      if (!this.minSize && is_min_size) {
        this.minSize = true;
        this.update();
      }
      if (this.minSize && !is_min_size) {
        this.minSize = false;
        this.update();
      }
      this.update();
    }
    const DM_GROUP_NAME = app.data.direct_message_name;

    this.getSectionedProjects = () => {

      let history_project_users = this.findHistoryProjects();

      let projects_group = _.groupBy(app.store.projectsUsersStore.items, (pu) => {
        if (pu.data.project_kind === 'direct') {
          return DM_GROUP_NAME;
        }

        let names = pu.data.project_name.split('/');
        return names.length >= 2 ? names[0] : 'Projects';
      });

      let temp = projects_group[DM_GROUP_NAME];
      delete projects_group[DM_GROUP_NAME];

      const HISTORY_SECTION_LABEL = '履歴';
      if (history_project_users?.length) {
        projects_group = {
          [HISTORY_SECTION_LABEL]: history_project_users,
          ...projects_group
        };
      }

      projects_group[DM_GROUP_NAME] = temp;
      const sections = {};

      for (const key in projects_group) {
        sections[key] = {
          projects: projects_group[key],
          isClose: sidebarSettings[app.store.workspace_id]?.[key]?.isClose || false,
        };
      }
      return sections;
    };

    this.hasMention = () => {
      return app.store.inboxesStore.items.some(inbox => inbox.isMention());
    };

    this.hasUnread = () => {
      let inboxes_length = app.store.inboxesStore.items.length;
      return inboxes_length > 0;
    };

    this.hasRemind = () => {
      let reminds_length = app.store.getWorkspaceUser().data.remind_count;
      return reminds_length > 0;
    };

    this.scrollToActive = () => {
      let project_tags = this.refs.project;
      if(!project_tags) return;

      project_tags = Array.isArray(project_tags) ? project_tags : [project_tags];

      let active_project = project_tags.find(item => item.isActive());
      if (!active_project) return;
      requestAnimationFrame(() => {
        active_project.root.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
        });
      });
    };

    this.onToggleOpen = () => {
      alert('開閉機能未実装');
    };

    this.openSwitcher = () => {
      app.shortcut.run('openSwitcher');
    };

    this.onOpenActionSheet = (e) => {
      e.preventDefault();
      e.stopPropagation();

      let options = [
        {
          label: 'ワークスペース設定',
          icon: 'setting',
          action: () =>{ popup.close(); this.moveWorkspaceSettings(); }
        },
        {
          label: 'プロジェクト作成',
          icon: 'add',
          action: () =>{ popup.close(); this.openModalProject(); }
        },
      ];

      const popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 4,
        offsetLeft: 74,
        position: 'bottom',
        opts: {
          options: options,
        },
      });
    };

    this.moveWorkspaceSettings = () => {
      spat.router.push(`/${app.store.workspace.path}/settings`);
    };

    this.isActive = (path) => {
      let path_name = location.pathname.split('/');
      let current_path = path_name[3];

      if (current_path !== "notifications") return current_path === path;

      let current_tab = path_name[4];
      if (!current_tab) return current_path === path;

      if (current_tab === "activities") return current_path === path;

      return current_tab === path;
    };

    this.openPopupNotifications = (e) => {
      e.preventDefault();
      e.stopPropagation();
      spat.popup.open('popup-notifications', {
        offsetLeft: 16,
        position: "right",
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        opts: { current: e.currentTarget.dataset.current },
      });
    };

    this.openModalProject = async () => {
      let modal = spat.modal.open('modal-project');
      let result = await modal.waitClose();
      if (!result) return;
      this.update();
    };

    this.findHistoryProjects = () => {
      let project_ids = app.utils.history.load().projects;

      if (!project_ids?.length) return ;

      return project_ids.map(id => {
        let item = app.store.projectsUsersStore.items.find(project => {
          return project.id === id;
        });

        return item ? item : null;
      }).filter(Boolean);
    };

    this.dashboardItems = [
      {
        name: '未読',
        icon: 'unread',
        status: '全て確認済み',
        get status() {
          return this.count ? ` ${this.count} 件の未読` : 'すべて確認済み';
        },
        action: () => {
          capacitor.hapticsImpactLight();

          const encoded_query = encodeURIComponent(`unread:true`);
          spat.router.push(`/workspaces/${app.store.workspace_id}/inboxes?q=${encoded_query}`);
        },
        get count() { return app.store.inboxesStore.items.length },
      },
      {
        name: 'お気に入り',
        icon: 'bookmark',
        get status() {
          return this.count ? ` ${this.count} 個のアイテム` : 'すべて確認済み';
        },
        action: () => {
          capacitor.hapticsImpactLight();
          const encoded_query = encodeURIComponent("favorite:true");
          spat.router.push(`/workspaces/${app.store.workspace_id}/search?q=${encoded_query}`);
        },
        get status() {
          return `@${app.store.currentUser.data.screen_name}`;
        },
      },
      {
        name: 'マイタスク',
        icon: 'mypage',

        get status() {
          return `@${app.store.currentUser.data.screen_name}`;
        },
        action: () => {
          capacitor.hapticsImpactLight();

          const encoded_query = encodeURIComponent(`assigned:${app.store.currentUser.data.screen_name} ignore_column:done,close`);
          spat.router.push(`/workspaces/${app.store.workspace_id}/search?q=${encoded_query}`);
        },

      },
      {
        name: '後で',
        icon: 'remind',
        get status() {
          return this.count ? ` ${this.count} 個のアイテム` : 'すべて確認済み';
        },
        action: () => {
          capacitor.hapticsImpactLight();
          spat.router.push(`/workspaces/${app.store.workspace_id}/notifications/reminds`);
        },
        get count() { return app.store.getWorkspaceUser().data.remind_count },
      },
    ];

});
riot.tag2('module-project-section_', '<div class="f fbw py7 text-label_white_medium hover-trigger cursor-pointer {opts.minSize ? &quot;px5&quot; : &quot;px12&quot;}" onclick="{onToggleOpen}"> <div class="f fm hover-text-white"> <div class="f fh {opts.minSize ? &quot;pr5&quot; : &quot;py3 pr8&quot;}"><i class="icon-arrow-down transition fs10 {&quot;rotate-n90&quot; : opts.isClose}"></i></div> <div class="flex-fixed font-lato bold {&quot;fs12&quot; : opts.minSize}">{opts.key}</div> </div> <div class="s16 cursor-pointer tooltip" if="{opts.key === &quot;Direct Message&quot; || app.store.workspace_user.data.role !== &quot;guest&quot;}" aria-label="{opts.key}に作成" data-tooltip-position="right" data-tooltip-offset-left="16"><i class="icon-add fs16 hover-show" onclick="{onOpenModalProject}"> </i></div> </div> <div class="{&quot;row px8&quot; : !opts.minSize &amp;&amp; opts.isClose}" if="{!opts.minSize || !opts.isClose}"> <div ref="project" each="{project_user in opts.items}" data-is="item-project" item="{project_user}" icon_view="{parent.opts.isClose}" min-size="{parent.opts.minSize}"></div> </div>', '', '', function(opts) {

    this.mixin('enableOptsEventHandler');

    this.onToggleOpen = () => {
      this.trigger('toggle', {
        key: this.opts.key,
        isClose: !this.opts.isClose,
      });
      this.update();
    };

    this.onOpenModalProject = async (e) => {
      const HISTORY_SECTION_LABEL = '履歴';
      if (e.item.key === HISTORY_SECTION_LABEL) {
        spat.modal.alert(`${HISTORY_SECTION_LABEL}には追加できません。`);
        return;
      }

      e.stopPropagation();

      let key;
      if (e && e.item && e.item.key !== 'Projects') {
        key = e.item.key;
      }
      let modal = spat.modal.open('modal-project', {
        section: key,
        isDM: key === app.data.direct_message_name,
      });
      let result = await modal.waitClose();
      if (!result) return;
      this.update();
    };
});